import { type ReactNode } from 'react';

type Props = {
  loading: boolean;
  skeleton?: ReactNode;
  children: ReactNode;
  className?: string;
  minHeight?: string;
  deferSkeletonMs?: number;
  lift?: boolean;
};

/**
 * Shows skeleton while loading, then children. No opacity animations — avoids blank gaps.
 */
export function AsyncContentReveal({
  loading,
  skeleton,
  children,
  className = '',
  minHeight = 'min-h-[420px]',
}: Props) {
  return (
    <div className={`${minHeight} ${className}`.trim()}>
      {loading && skeleton != null ? skeleton : children}
    </div>
  );
}
